<template>
  <b-modal
    @hidden="CLEAR_SUBCOMPANIES"
    :visible="subcompanies.length > 0"
    size="xl"
    hide-footer
    body-class="p-0"
    id="client-portfolio-subcompany"
  >
    <template #modal-header="{ hide }">
      <div class="d-flex align-items-center w-100 py-3">
        <h3 class="m-0">Все компании структуры {{ parent_subcompanies }}</h3>
        <b-icon-x @click="hide" font-scale="2" class="ml-auto cursor-pointer"></b-icon-x>
      </div>
    </template>
    <ClientPortfolioTable
      max-height="70vh"
      :needHeader="false"
      :tableData="subcompanies"
      :tableFields="tableFields"
    ></ClientPortfolioTable>
  </b-modal>
</template>

<script>
import { mapState, mapGetters, mapMutations } from "vuex";

export default {
  data() {
    return {
      tableFields: [
        {
          label: "ID",
          key: "id",
          rowspan: "1",
          sortable: true,
          visible: false,
          thStyle: {
            width: "50px",
          },
          tdAttr: {
            "data-t": "n",
          },
        },
        {
          label: "Имя компании",
          sortable: true,
          key: "name",
        },
        {
          label: "Менеджер ТО",
          sortable: true,
          key: "to_manager_name",
        },       
        {
          label: "ИНН",
          key: "inn",
          thStyle: {
            width: "150px",
          },
        },
        {
          label: "Все",
          key: "all",
          sortable: true,
          sortByFormatted: true,
          formatter: (value) => value.length,
          thStyle: {
            width: "100px",
          },
          tdAttr: {
            "data-t": "n",
          },
        },
      ],
    };
  },

  components: {
    ClientPortfolioTable: () =>
      import("@components/clientPortfolio/ClientPortfolioTable"),
  },

  computed: {
    ...mapState("clientPortfolio", {
      parent_subcompanies: (state) => state.parent_subcompanies,
    }),
    ...mapGetters("clientPortfolio", ["subcompanies"]),
  },

  methods: {
    ...mapMutations("clientPortfolio", ["CLEAR_SUBCOMPANIES"]),
  },
};
</script>
